import type { UUID } from "@/core/types";

import { useCreateNoteAddendum } from "../../api/mutations/useCreateNoteAddendum";

import { AcaAddendumForm } from "./AcaAddendumForm";

type CreateAcaAddendumProps = {
  credentials: string | undefined;
  noteId: UUID;
  onCancel: () => void;
  onSuccess: () => void;
  patientId: UUID;
  signature: string | undefined;
};

export function CreateAcaAddendum({
  credentials,
  noteId,
  onCancel,
  onSuccess,
  patientId,
  signature,
}: CreateAcaAddendumProps) {
  const { isPending, mutate } = useCreateNoteAddendum({ onSuccess });

  return (
    <AcaAddendumForm
      isPending={isPending}
      mutate={({ addendum, ...additionalContent }) =>
        mutate({ addendum, additionalContent, credentials, noteId, patientId, signature })
      }
      onCancel={onCancel}
    />
  );
}
